import {
   GET_ISABI_PERCENTAGES,
   CHANGE_VALUE_FORM_ISABI,
   SAVE_ISABI_PERCENTAGE,
   GET_ITEM_ISABI_PERCENTAGE,
   DEFAULT_ISABI_DATA,
   OPEN_CLOSE_BUDGET_ISABI,
   LIST_BUDGETS_ISABI_NOT_CONFIRMED,
   SELECTED_BUDGET_OPTION,
   SAVE_CONFIRM_PAYMENT_ISABI,
   LIST_BUDGETS_ISABI_CONFIRMED,
   GET_ITEM_ISABI_BUDGET
} from '../constants/isabi_taxes';

export const isabi_taxes = ( state = {}, action ) => {
   switch ( action.type ) { 

      case GET_ISABI_PERCENTAGES : {
         return action.payload;
      }

      case CHANGE_VALUE_FORM_ISABI : {
         return action.payload;
      }

      case SAVE_ISABI_PERCENTAGE : {
         return action.payload;
      }

      case GET_ITEM_ISABI_PERCENTAGE : {
         return action.payload;
      }

      case DEFAULT_ISABI_DATA : {
         return action.payload;
      }

      case OPEN_CLOSE_BUDGET_ISABI : {
         return action.payload;
      }

      case LIST_BUDGETS_ISABI_NOT_CONFIRMED : {
         return action.payload;
      }

      case SELECTED_BUDGET_OPTION : {
         return action.payload;
      }

      case SAVE_CONFIRM_PAYMENT_ISABI : {
         return action.payload;
      }

      case LIST_BUDGETS_ISABI_CONFIRMED : {
         return action.payload;
      }

      case GET_ITEM_ISABI_BUDGET : {
         return action.payload;
      }
 
     default :
     return state;
   }
}